var globalIsUsingStaticRendering = false;
export function useStaticRendering(enable) {
    globalIsUsingStaticRendering = enable;
}
export function isUsingStaticRendering() {
    return globalIsUsingStaticRendering;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-react-lite/es/staticRendering.js
// module id = 250
// module chunks = 0